
@if (configState$ | async; as configState) {
  @if (configState.status === 'ready') {
    <div class="app-page-shell">
      <router-outlet (activate)="onActivate($event)" >
        <app-spinner></app-spinner>
      </router-outlet>
      <app-footer></app-footer>
    </div>
    <!-- end modal-shared -->
    <button id="openSuccessButton"  [class.is-hidden]="isHidden" data-toggle="modal" data-target="#signupSuccess">Open Modal</button>
    <button id="openModalReset"  [class.is-hidden]="isHidden" data-toggle="modal" data-target="#resetPassModal">Open Modal</button>
    <button id="openCodeButton"  [class.is-hidden]="isHidden" data-toggle="modal" data-target="#passCodeModal">Open Modal</button>
    <button id="openUpdatePassword"  [class.is-hidden]="isHidden" data-toggle="modal" data-target="#passwordUpdateModal">Open Modal</button>
    <button id="openResetSuccessButton"  [class.is-hidden]="isHidden" data-toggle="modal" data-target="#resetSuccess">Open Modal</button>
    <div class="modal-popup">
      <div
        class="modal fade"
        id="signupPopupForm"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
        >
        <div class="modal-dialog modal-dialog-centered auth-prototype-dialog" role="document">
          <div class="modal-content auth-prototype-card">
            <div class="auth-prototype-tabs">
              <button type="button" data-dismiss="modal" data-toggle="modal" data-target="#loginPopupForm">Log in</button>
              <button type="button" class="is-active">Sign up</button>
            </div>
            <div class="modal-header auth-prototype-header">
              <div>
                <h5 class="modal-title title" id="exampleModalLongTitle">
                  Create your account
                </h5>
                <p>Sign up to book faster and manage your trips.</p>
              </div>
              <button
                type="button"
                class="close"
                id="closeSignup"
                data-dismiss="modal"
                aria-label="Close"
                >
                <span aria-hidden="true" class="la la-close"></span>
              </button>
            </div>
            <div class="modal-body auth-prototype-body">
              <div class="contact-form-action">
                <form class="auth-prototype-form" id="ngFormSignup" novalidate [formGroup]="signupForm" (ngSubmit)="submitSignUp()">
                  <div class="input-box">
                    <label class="label-text" for="first_name">First name</label>
                    <div class="form-group">
                      <span class="la la-user form-icon"></span>
                      <input
                        class="form-control"
                        type="text"
                        name="first_name"
                        id="first_name"
                        formControlName="first_name"
                        placeholder="Enter your first name"
                        />
                    </div>
                    @if (submitted && f.first_name.errors) {
                      <div class="invalid-feedback-signup">
                        @if (f.first_name.errors.required) {
                          <div class="invalid-select">First name is required!</div>
                        }
                        @if (f.first_name.errors.pattern) {
                          <div class="invalid-select">Your firstname should not contain numbers or spaces</div>
                        }
                      </div>
                    }
                    @if (!loadingSignup &&  user) {
                      <div class="invalid-feedback-signup">
                        <div class="invalid-select "  >{{user.getFname()}}</div>
                      </div>
                    }
                  </div>
                  <div class="input-box">
                    <label class="label-text" for="last_name">Last name</label>
                    <div class="form-group">
                      <span class="la la-user form-icon"></span>
                      <input
                        class="form-control"
                        type="text"
                        name="last_name"
                        id="last_name"
                        formControlName="last_name"
                        placeholder="Enter your last name"
                        />
                    </div>
                    @if (submitted && f.last_name.errors) {
                      <div class="invalid-feedback-signup">
                        @if (f.last_name.errors.required) {
                          <div class="invalid-select">Your lastname is required!</div>
                        }
                        @if (f.last_name.errors.pattern) {
                          <div class="invalid-select">Your lastname should not contain numbers or spaces</div>
                        }
                      </div>
                    }
                    @if (!loadingSignup &&  user) {
                      <div class="invalid-feedback-signup">
                        <div class="invalid-select "  >{{user.getLname()}}</div>
                      </div>
                    }
                  </div>
                  <div class="input-box">
                    <label class="label-text" for="id_number">National ID / Passport</label>
                    <div class="form-group">
                      <span class="la la-user form-icon"></span>
                      <input
                        class="form-control"
                        type="text"
                        name="id_number"
                        id="id_number"
                        formControlName="id_number"
                        placeholder="Enter ID or passport number"
                        />
                    </div>
                    @if (submitted && f.id_number.errors) {
                      <div class="invalid-feedback-signup">
                        @if (f.id_number.errors.minlength) {
                          <div class="invalid-select">ID/PASSPORT should be between 7 to 14 characters</div>
                        }
                        @if (f.id_number.errors.maxlength) {
                          <div class="invalid-select">ID/PASSPORT should be between 7 to 14 characters</div>
                        }
                        @if (f.id_number.errors.required) {
                          <div class="invalid-select">ID/PASSPORT is required!</div>
                        }
                        @if (f.id_number.errors.pattern) {
                          <div class="invalid-select">ID/PASSPORT must be between 7 to 14 characters</div>
                        }
                      </div>
                    }
                    @if (!loadingSignup &&  user) {
                      <div class="invalid-feedback-signup">
                        <div class="invalid-select "  >{{user.getIdno()}}</div>
                      </div>
                    }
                  </div>
                  <div class="input-box">
                    <label class="label-text" for="phone_number">Phone number</label>
                    <div class="form-group">
                      <span class="la la-user form-icon"></span>
                      <input
                        class="form-control"
                        type="text"
                        name="phone_number"
                        id="phone_number"
                        formControlName="phone_number"
                        placeholder="e.g. 0712 345 678"
                        />
                    </div>
                    @if (submitted && f.phone_number.errors) {
                      <div class="invalid-feedback-signup">
                        @if (f.phone_number.errors.required) {
                          <div class="invalid-select">Your phone numberis required!</div>
                        }
                        @if (f.phone_number.errors.pattern) {
                          <div class="invalid-select">Your phone number should not contain numbers or spaces</div>
                        }
                      </div>
                    }
                    @if (!loadingSignup &&  user) {
                      <div class="invalid-feedback-signup">
                        <div class="invalid-select "  >{{user.getPhone()}}</div>
                      </div>
                    }
                  </div>
                  <!-- end input-box -->
                  <div class="input-box">
                    <label class="label-text" for="email">Email address</label>
                    <div class="form-group">
                      <span class="la la-envelope form-icon"></span>
                      <input
                        class="form-control"
                        name="email"
                        id="email"
                        formControlName="email"
                        placeholder="you@example.com"
                        />
                    </div>
                    @if (submitted && f.email.errors) {
                      <div class="invalid-feedback-signup">
                        @if (f.email.errors.required) {
                          <div class="invalid-select">Email is required!</div>
                        }
                        @if (f.email.errors.email) {
                          <div class="invalid-select">Email must be a valid email address</div>
                        }
                      </div>
                    }
                    @if (!loadingSignup &&  user) {
                      <div class="invalid-feedback-signup">
                        <div class="invalid-select "  >{{user.getEmail()}}</div>
                      </div>
                    }
                  </div>
                  <!-- end input-box -->
                  <div class="input-box">
                    <label class="label-text" for="signup-password">Password</label>
                    <div class="form-group">
                      <span class="la la-lock form-icon"></span>
                      <input
                        class="form-control"
                        type="password"
                        id="signup-password"
                        name="password"
                        formControlName="password"
                        placeholder="At least 6 characters"
                        />
                    </div>
                    @if (submitted && f.password.errors) {
                      <div class="invalid-feedback-signup">
                        @if (f.password.errors.required) {
                          <div class="invalid-select">Password is required!</div>
                        }
                        @if (f.password.errors.minlength) {
                          <div class="invalid-select">Your password should not be less than 6 characters</div>
                        }
                      </div>
                    }
                  </div>
                  <!-- end input-box -->
                  <p class="auth-privacy">By submitting my personal data, I consent to {{ config?.site?.name }} collecting, processing, and storing my information in accordance with the
                    @if (config?.site?.privacyPolicyUrl) {
                      <a [href]="config.site.privacyPolicyUrl" target="_blank" rel="noopener noreferrer"><u>{{ config?.site?.name }} Privacy Policy</u></a>.
                    } @else {
                      <a routerLink="/privacy-policy" data-dismiss="modal" aria-label="Close"><u>{{ config?.site?.name }} Privacy Policy</u></a>.
                    }
                  </p>
                    <!-- end input-box -->
                    <div class="btn-box pt-3 pb-4">
                      <button type="submit" class="theme-btn border-theme w-100">
                        @if (loadingSignup) {
                          <img src="assets/gifs/rll.gif">
                        }
                        @if (!loadingSignup) {
                          <span>Create account</span>
                        }
                      </button>
                    </div>
                  </form>
                </div>
                <!-- end contact-form-action -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end modal-popup -->
      <!-- end modal-shared -->
      <div class="modal-popup">
        <div
          class="modal fade"
          id="loginPopupForm"
          tabindex="-1"
          role="dialog"
          aria-hidden="true"
          >
        <div class="modal-dialog modal-dialog-centered auth-prototype-dialog" role="document">
          <div class="modal-content auth-prototype-card otp-auth-card">
            <button type="button" class="otp-auth-close" id="closeLogin" data-dismiss="modal" aria-label="Close" (click)="resetOtpAuth()">×</button>

            @if (authStep === 'sending' || authStep === 'verifying') {
              <div class="otp-auth-status" role="status" aria-live="polite">
                <span class="otp-auth-spinner" aria-hidden="true"></span>
                <h3>{{ authStep === 'sending' ? 'Sending your code…' : 'Verifying…' }}</h3>
                <p>{{ authStep === 'sending' ? 'This only takes a moment.' : 'Signing you in securely.' }}</p>
              </div>
            } @else if (authStep === 'done') {
              <div class="otp-auth-status" role="status" aria-live="polite">
                <span class="otp-auth-success" aria-hidden="true">✓</span>
                <h3>You’re signed in</h3>
                <p>Taking you to your bookings…</p>
              </div>
            } @else if (authStep === 'verify') {
              <div class="otp-auth-verify">
                <button type="button" class="otp-auth-back" (click)="editAuthIdentifier()">← <span>Back</span></button>
                <h3>Enter your code</h3>
                <p>We sent a 6-digit code by <strong>{{ authChannel === 'email' ? 'email' : 'SMS' }}</strong> to</p>
                <div class="otp-auth-destination">
                  <strong>{{ maskedAuthIdentifier }}</strong>
                  <button type="button" (click)="editAuthIdentifier()">Change</button>
                </div>

                <form [formGroup]="otpCodeForm" (ngSubmit)="verifyOtp()">
                  <div class="otp-code-grid">
                    @for (index of [0, 1, 2, 3, 4, 5]; track index) {
                      <input
                        type="text"
                        inputmode="numeric"
                        maxlength="6"
                        [formControlName]="'d' + index"
                        [attr.data-otp-index]="index"
                        [attr.aria-label]="'OTP digit ' + (index + 1)"
                        (input)="onOtpInput($event, index)"
                        (keydown)="onOtpKeydown($event, index)">
                    }
                  </div>
                  @if (authError) {
                    <p class="otp-auth-error" role="alert">{{ authError }}</p>
                  }
                  <button type="submit" class="otp-auth-submit">Verify &amp; continue</button>
                </form>

                <p class="otp-auth-resend">
                  @if (authResendSeconds > 0) {
                    Resend code in <strong>{{ authResendSeconds }}s</strong>
                  } @else {
                    <button type="button" (click)="resendOtp()">Resend code</button>
                  }
                </p>
              </div>
            } @else {
              <div class="otp-auth-identify">
                <img [src]="config?.self?.logo || 'assets/images/logo.webp'" [alt]="config?.site?.name || 'Operator'">
                <h3>Sign in or create account</h3>
                <p>We’ll send a one-time code — no password to remember.</p>

                <div class="otp-auth-modes" role="tablist" aria-label="Code delivery method">
                  <button type="button" [class.is-active]="authMode === 'phone'" [attr.aria-selected]="authMode === 'phone'" (click)="setAuthMode('phone')">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"><rect x="7" y="2" width="10" height="20" rx="2"/><path d="M11 18h2"/></svg>
                    Mobile
                  </button>
                  <button type="button" [class.is-active]="authMode === 'email'" [attr.aria-selected]="authMode === 'email'" (click)="setAuthMode('email')">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>
                    Email
                  </button>
                </div>

                <form [formGroup]="otpAuthForm" (ngSubmit)="requestOtp()">
                  <label for="otp-auth-identifier">{{ authMode === 'phone' ? 'Mobile number' : 'Email address' }}</label>
                  <div class="otp-auth-input" [class.has-error]="authError">
                    @if (authMode === 'phone') {
                      <span class="otp-phone-prefix">🇰🇪 <strong>+254</strong></span>
                      <input id="otp-auth-identifier" type="tel" inputmode="tel" autocomplete="tel" formControlName="identifier" placeholder="712 345 678" (input)="authError = ''">
                    } @else {
                      <span class="otp-email-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>
                      </span>
                      <input id="otp-auth-identifier" type="email" inputmode="email" autocomplete="email" formControlName="identifier" placeholder="you@example.com" (input)="authError = ''">
                    }
                  </div>
                  @if (authError) {
                    <p class="otp-auth-error" role="alert">{{ authError }}</p>
                  }
                  <button type="submit" class="otp-auth-submit">
                    Send code
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"><path d="M5 12h14M13 5l7 7-7 7"/></svg>
                  </button>
                </form>

                <div class="otp-auth-benefits">
                  @for (benefit of ['Manage and reschedule your bookings', 'Faster checkout — details saved', 'All your tickets in one place']; track benefit) {
                    <p><span>✓</span>{{ benefit }}</p>
                  }
                </div>
                <p class="otp-auth-privacy-note">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"><rect x="4" y="10" width="16" height="10" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>
                  Your details are kept private and secure
                </p>
              </div>
            }
          </div>
        </div>
      </div>
      </div>
      <!-- end modal-popup -->
      <!-- Modal -->
      <div class="modal-popup">
        <div id="signupSuccess" class="modal fade" role="dialog">
          <div class="modal-dialog  modal-dialog-centered">
            <!-- Modal content-->
            <div class="modal-content">
              <div class="modal-header">
                <button id="closeSuccess" type="button" class="close" data-dismiss="modal">&times;</button>
                <br>
                  <div class="modal-body">
                    <h4 class="theme-payment-page-signin-title review-header _ml-10">Success</h4>
                    <div class="facebook-login__disclaimer  _mb-20 _ml-10">
                      <p class="paragraphRegular">Thank you for registering with Buupass, kindly go to your email and click the confirmation link. Thank you .</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal -->
        <!-- Reset modal -->
        <div class="modal-popup">
          <div
            class="modal fade"
            id="resetPassModal"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
            >
            <div class="modal-dialog modal-dialog-centered" role="document">
              <!-- Modal content-->
              <div class="modal-content">
                <div class="modal-header">
                  <button id="closeReset" type="button" class="close" data-dismiss="modal">&times;</button>
                  <br>
                    <div class="modal-body">
                      <h4 class="theme-payment-page-signin-title review-header _ml-15">Recover your account  </h4>
                      <div class="facebook-login__disclaimer  _mb-20 _ml-15">
                        <p class="paragraphRegular">We can help you reset your password. First, enter your email and follow the instructions.</p>
                      </div>
                      @if (!resetsubmitted &&  successReset) {
                        <div class="success-feedback">
                          <div class="success-select _ml-10"  >{{resetSuccessMsg}}</div>
                        </div>
                      }
                      <!-- <div class="or__splitter"><span>or</span></div> -->
                      <form [formGroup]="resetForm" id="resetForm" (ngSubmit)="submitResetPassword()" >
                        <div class="form-row  _mb-20 ">
                          <div class="col-sm-8 my-1">
                            <label class="sr-only" for="inlineFormInputEmailHome">Email</label>
                            <input type="text"
                              class="form-control"
                              id="inlineFormInputEmailHome"
                              placeholder="e.g your@email.com"
                              name="email"
                              formControlName="email"
                              >
                            @if (resetForm.get('email').touched && resetForm.get('email').hasError('required')) {
                              <small class=" _ml-10 invalid-select">Please enter your email</small>
                            }
                            @if (resetForm.get('email').touched && resetForm.get('email').hasError('email')) {
                              <small class=" _ml-10 invalid-select">Should be a valid email address</small>
                            }
                          </div>
                          <!-- end input-box -->
                          <div class="btn-box  pb-4">
                            <button type="submit" class="theme-btn border-theme w-100">
                              @if (loadingReset) {
                                <img src="assets/gifs/rll.gif">
                              }
                              @if (!loadingReset) {
                                <span>SUBMIT</span>
                              }
                            </button>
                          </div>
                        </div>
                      </form>
                      <div  class="invalid-feedback">
                        <div class="invalid-select _ml-10"  >{{resetErrMsg}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal -->
          <!-- modal update password -->
          <div class="modal-popup">
            <div id="passwordUpdateModal" class="modal fade" role="dialog">
              <div class="modal-dialog modal-dialog-centered">
                <!-- Modal content-->
                <div class="modal-content">
                  <div class="modal-header">
                    <button id="closePasswordUpdate" type="button" class="close" data-dismiss="modal">&times;</button>
                    <br>
                      <div class="modal-body">
                        <h4 class="theme-payment-page-signin-title review-header _ml-15">    Reset your password       </h4>
                        <div class="facebook-login__disclaimer  _mb-20 _ml-15">
                          <p class="paragraphRegular">8-character minimum; case sensitive.</p>
                        </div>
                        <!-- <div class="or__splitter"><span>or</span></div> -->
                        <form [formGroup]="passwordUpdateForm" id="passwordUpdateForm" (ngSubmit)="updatePassword()" >
                          <div class="form-row  _mb-20 ">
                            <div class="col-sm-6 my-1">
                              <label class="sr-only" for="inlineFormInputPassword">Password</label>
                              <input type="password"
                                class="form-control"
                                id="inlineFormInputPassword"
                                placeholder="Password"
                                name="password"
                                formControlName="password"
                                >
                            </div>
                            <div class="col-sm-6 my-1">
                              <label class="sr-only" for="inlineFormInputConfirmPassword">Re-enter Password</label>
                              <input type="password"
                                class="form-control"
                                id="inlineFormInputConfirmPassword"
                                placeholder="Re-enter Password"
                                name="confirmpassword"
                                formControlName="confirmpassword"
                                >
                              @if (passwordUpdateForm.get('password').touched && passwordUpdateForm.get('password').hasError('required')) {
                                <small class=" _ml-10 invalid-select">Please enter password</small>
                              }
                              @if (passwordUpdateForm.get('password').touched && passwordUpdateForm.get('password').hasError('minlength')) {
                                <small class=" _ml-10 invalid-select">Should be 8-character minimum.</small>
                              }
                              @if (passwordUpdateForm.get('confirmpassword').touched && passwordUpdateForm.get('confirmpassword').hasError('confirmedValidator') ) {
                                <small class=" _ml-10 invalid-select">Password and Confirm Password must be match.</small>
                              }
                            </div>
                          </div>
                          <div class="form-row  _mb-20 ">
                            <div class="col-sm-6 my-1 _mt-20">
                              <button   form="passwordUpdateForm" class="theme-search-area-submit theme-search-area-submit-curved theme-search-area-submit-glow">
                                @if (loadingPasswordUpdate) {
                                  <img src="assets/gifs/rll.gif">
                                }
                                @if (!loadingPasswordUpdate) {
                                  <span>SUBMIT</span>
                                }
                              </button>
                            </div>
                          </div>
                        </form>
                        <div  class="invalid-feedback">
                          <div class="invalid-select _ml-10"  >{{codeSuccessMsg}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Modal -->
            <!-- reset code modal -->
            <div class="modal-popup">
              <div id="passCodeModal" class="modal fade" role="dialog">
                <div class="modal-dialog modal-dialog-centered">
                  <!-- Modal content-->
                  <div class="modal-content">
                    <div class="modal-header">
                      <button id="closeCode" type="button" class="close" data-dismiss="modal">&times;</button>
                      <br>
                        <div class="modal-body">
                          <h4 class="theme-payment-page-signin-title review-header _ml-15">Verify your identity</h4>
                          <div class="facebook-login__disclaimer  _mb-20 _ml-15">
                            <p class="paragraphRegular">We just sent a code to {{user_email_reset}}. Check your email for a message from Buupass, and enter the code here.</p>
                          </div>
                          <!-- <div class="or__splitter"><span>or</span></div> -->
                          <form [formGroup]="codeForm" id="codeForm" (ngSubmit)="submitCode()" >
                            <div class="form-row  _mb-20 ">
                              <div class="col-sm-6 my-1">
                                <label class="sr-only" for="inlineFormInputEmailHomeForm">Enter Code</label>
                                <input type="text"
                                  class="form-control"
                                  id="inlineFormInputEmailHomeForm"
                                  placeholder="Enter code"
                                  name="code"
                                  formControlName="code"
                                  >
                                @if (codeForm.get('code').touched && codeForm.get('code').hasError('required')) {
                                  <small class=" _ml-10 invalid-select">Please enter a code </small>
                                }
                              </div>
                              <div class="btn-box  pb-4">
                                <button type="submit" class="theme-btn border-theme heme-search-area-submit-curved theme-search-area-submit-glow w-100">
                                  @if (loadingCode) {
                                    <img src="assets/gifs/rll.gif">
                                  }
                                  @if (!loadingCode) {
                                    <span>SUBMIT</span>
                                  }
                                </button>
                              </div>
                            </div>
                          </form>
                          @if (!codeubmitted ) {
                            <div class="invalid-feedback">
                              <div class="invalid-select _ml-10"  >{{updatePassSuccessMsg}}</div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- reset success modal -->
              <div id="resetSuccess" class="modal fade" role="dialog">
                <div class="modal-dialog">
                  <!-- Modal content-->
                  <div class="modal-content">
                    <div class="modal-header">
                      <button id="closeResetSuccess" type="button" class="close" data-dismiss="modal">&times;</button>
                      <br>
                        <div class="modal-body">
                          <h4 class="theme-payment-page-signin-title review-header _ml-10">Success</h4>
                          <div class="facebook-login__disclaimer  _mb-20 _ml-10">
                            <p class="paragraphRegular">Your password has been updated successfully. Thank you .</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              } @else {
                <main class="configuration-state" role="main" aria-labelledby="configuration-title">
                  <div class="configuration-state__card">
                    <div class="configuration-state__mark" aria-hidden="true">!</div>
                    <h1 id="configuration-title">Operator unavailable</h1>
                    <p>{{ configState.error || 'This operator configuration could not be loaded.' }}</p>
                    <button type="button" class="configuration-state__action" (click)="reloadPage()">
                      Try again
                    </button>
                  </div>
                </main>
              }
            }
